type ChevronUpDownProps = {
  color: string
  draw?: 'stroke' | 'fill'
  className?: string
  strokeWidth?: string
}

export const ChevronUpDown = ({ color, className, strokeWidth = '2' }: ChevronUpDownProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8 9.5L12 5.5L16 9.5M8 14.5L12 18.5L16 14.5"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
